import styled from "styled-components";

export const InvoiceWrapper = styled.div`
  padding: 24px;
  padding-bottom: 32px;
  border-radius: var(
    --box-wrapper-section-border-radius,
    var(--section-8px-border-radius, var(--8px))
  );
  background: ${"var(--section-snow-background-color,var(--snow))"} !important;

  overflow: scroll;
  /* Hide scrollbar for Chrome, Safari and Opera */
  &::-webkit-scrollbar {
    display: none;
  }
  /* Hide scrollbar for IE, Edge and Firefox */
  & {
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
  }
`;

export const TableHeader = styled.th`
  color: var(--section-granite-color, var(--granite));
  text-align: left;
  font-size: 13px;
  font-weight: 600;
  line-height: 16px;
  padding-bottom: 4px;
  &:last-child {
    padding-right: 40px !important;
  }
  &:first-child {
    padding-left: 16px !important;
  }
`;

export const TableHead = styled.thead`
  border-bottom: 1px solid
    ${"var(--invoice-project-title-line-section-border-color,var(--section-stone-border-color,var(--stone)))"};
  padding-bottom: 4px;
`;

interface TableProps {
  padding?: string;
}

export const Table = styled.table<TableProps>`
  width: 100%;
  border-collapse: collapse;
  padding: ${({ padding }) => padding || "auto"};
`;

export const TR = styled.tr`
  th:last-child {
    display: flex;
    justify-content: end;
  }
`;
